import gql from 'graphql-tag'

export const GetOrganizationsById = gql`
  query GetOrganizationsById($id: ID!) {
    organizations(input: { ids: [$id] }) {
      count,
      results {
        id,
        name,
        emr {
          id,
          type,
          secondaryType,
          capabilities {
            multipleNotesAllowed,
            destinations,
            predefinedSections,
            sections {
              id,
              name
            }
          },
          configurations {
            is_red_rover_org,
            submit_notes_as_preliminary
          }
        }
      }
    }
  }
`

export const GetEnhancedReviewByOrganizationId = gql`
  query GetOrganizationsById($id: ID!) {
    organizations(input: { ids: [$id] }) {
      count,
      results {
        id,
        name,
        enhancedReview
      }
    }
  }
`